import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { ShipmentLabelGenerationModel } from 'src/app/features/model/hawb.model';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { QrCodeComponent } from 'ng-qrcode';
import {
  ibcAddress,
  popupButtons,
  shipmentLabelKeys,
} from '../../utility/constants';
import {
  isPrintPayloadMessage,
  startPrintPreviewReadyNotifier,
} from '../../utility/print-layout.util';

@Component({
  selector: 'app-shipment-label-generation',
  standalone: true,
  imports: [CommonModule, MaterialModule, NgxBarcode6Module, QrCodeComponent],
  templateUrl: './shipment-label-generation.component.html',
  styleUrl: './shipment-label-generation.component.scss',
})
export class ShipmentLabelGenerationComponent implements OnInit, OnDestroy {
  private printPayloadReceived = false;
  private stopReadyNotifier?: () => void;
  public shipperInfo!: Array<Record<string, unknown>>;
  public consigneeInfo!: Array<Record<string, unknown>>;
  public shipmentInfo!: Record<string, unknown>;
  public shipmentExt!: string;
  public qrData!: string;
  public popupButtons = popupButtons;
  public isShipmentLabelPrinted = false;
  public ibcHeaderAddress = ibcAddress;
  constructor() {
    window.addEventListener('message', this.eventHandler);
  }

  ngOnInit(): void {
    this.stopReadyNotifier = startPrintPreviewReadyNotifier(
      () => this.printPayloadReceived
    );
  }

  ngOnDestroy(): void {
    this.stopReadyNotifier?.();
    window.removeEventListener('message', this.eventHandler);
  }

  public print() {
    this.isShipmentLabelPrinted = true;
    window.onafterprint = () => {
      window.close();
    };
    setTimeout(() => {
      window.print();
    }, 0);
  }

  public closePreviewWindow() {
    window.close();
  }

  public renderShipmentKeyValues(key: string) {
    return shipmentLabelKeys[key] ? shipmentLabelKeys[key] : '';
  }

  private readonly eventHandler = (event: MessageEvent) => {
    // Only the label payload from the opener; ignore any other message.
    if (isPrintPayloadMessage(event, ['shipmentExt', 'consigneeInfo'])) {
      this.printPayloadReceived = true;
      this.stopReadyNotifier?.();
      this.extractLabelData(event.data);
    }
  };

  private extractLabelData(data: ShipmentLabelGenerationModel): void {
    this.shipmentExt = data.shipmentExt;
    this.shipperInfo = [data.shipperInfo];
    this.consigneeInfo = [data.consigneeInfo];
    this.shipmentInfo = data.body;
    this.qrData = `${data.consigneeInfo.consigneeName}, ${data.consigneeInfo.companyName}, ${data.consigneeInfo.addressLine1}, ${data.consigneeInfo.city}, ${data.consigneeInfo.state}, ${data.consigneeInfo.postalCode}, ${data.consigneeInfo.country} - ${data.consigneeInfo.countryCode}`;
  }
}
